import * as Redux from 'redux'
import { connect } from 'react-redux'
import { ChangeEvent, useEffect } from 'react'
import {
    FormControlLabel,
    FormHelperText,
    Grid,
    RadioGroup,
} from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import RegroundAction from '@ClientActions/reground.action'
import { RegroundTypes } from '@ClientStores/client.action-types'
import { BaseCheckBox } from '@Components/Form/BaseCheckBox/BaseCheckBox'
import BaseDatePicker from '@Components/Form/BaseDatePicker/BaseDatePicker'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import UploadImage from '@Components/Form/UploadImage/UploadImage'
import { BaseRadio } from '@Components/Form/BaseRadio/BaseRadio'
import BaseSelect from '@Components/Form/BaseSelect/BaseSelect'
import { FormService } from '@Services/form.service'
import { ICommonQuery } from '@Models/common.model'
import { CommonService } from '@Services/common.service'
import BaseCreatableSelect from '@Components/Form/BaseCreatableSelect/BaseCreatableSelect'
import UploadFiles from '@Components/UploadFile/UploadFiles'

interface IAccessoriesForm {
    control: any
    errors: any
    watch?: any
    reset?: any
    imageChanged: (e: string, type: string) => void
    fileChanged: (e: string, type: string) => void
    onRemoveImg: (type: string) => void
    removeFileUpload: (type: string) => void
    cities?: []
    states?: []
    getStates?: any
    getCities?: any
    setValue?: any
    isDetailPage?: boolean
    isDisabled?: boolean
    isClearAccessoryForm?: boolean
    productDetail?: any
}
const AccessoriesForm = (props: IAccessoriesForm) => {
    const {
        control,
        errors,
        watch,
        reset,
        imageChanged,
        onRemoveImg,
        fileChanged,
        removeFileUpload,
        getStates,
        getCities,
        cities,
        states,
        setValue,
        isDisabled,
        isDetailPage,
        isClearAccessoryForm,
        productDetail,
    } = props
    const ac = new AbortController()

    const handleSelectChange = (
        value: any,
        type: string,
        isCreatePage = true
    ) => {
        switch (type) {
            case 'STATE': {
                if (isCreatePage) setValue('accessorySeller.city', null)

                const params = {
                    parentCode: value,
                }
                getCities(params)
                break
            }
            default:
                break
        }
    }

    const watchAccessory = watch('accessory')
    const watchAccessorySeller = watch('accessorySeller')

    useEffect(() => {
        handleSelectChange(watchAccessorySeller?.state, 'STATE', false)
    }, [watchAccessorySeller?.state])

    useEffect(() => {
        return () => {
            ac.abort()
        }
    }, [])

    useEffect(() => {
        getStates({ codes: 'CALIFORNIA' })
        getCities(watchAccessorySeller?.state)
        if (isClearAccessoryForm) {
            setValue('accessory', {
                make: '',
                firearmModel: '',
                semiAuto: 'false',
                roundCapacity: '',
                caliber: '',
                dateOfPurchase: null,
                firearmType: 'RIFLE',
                imageUrl: '',
                imageId: '',
                loading: false,
            })
            setValue('accessorySeller', {
                file: {
                    id: '',
                    name: '',
                    url: '',
                },
                ffl: '',
                businessName: '',
                address: '',
                city: null,
                state: null,
                zipCode: '',
                loading: false,
            })
        }
    }, [])

    return (
        <div>
            {/* <p className="page-title">Accessories</p> */}
            <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                    <Controller
                        control={control}
                        name="accessory.make"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                label="Make"
                                className="reddit-input w-100"
                                variant="filled"
                                disabled={isDisabled}
                                error={errors?.accessory?.make && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'accessory.make',
                                    'Make'
                                )}
                            />
                        )}
                    />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <Controller
                        control={control}
                        name="accessory.firearmModel"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                label="Firearm Model"
                                className="reddit-input w-100"
                                variant="filled"
                                disabled={isDisabled}
                                error={errors?.accessory?.firearmModel && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'accessory.firearmModel',
                                    'Firearm Model'
                                )}
                            />
                        )}
                    />
                </Grid>
                <Grid item sm={4} xs={12}>
                    {/* <div className="page-gray-card radio-card">
                        <p className="m-0 gray-text mr-2 w-50">
                            Semi Automatic
                        </p>
                        <Controller
                            control={control}
                            name="accessory.semiAuto"
                            defaultValue=""
                            render={({ field: { onChange, value } }) => (
                                <RadioGroup
                                    className="d-flex flex-row align-items-center flex-nowrap"
                                    value={value}
                                    onChange={(e) => {
                                        onChange(e)
                                    }}
                                >
                                    <FormControlLabel
                                        control={
                                            <BaseRadio
                                                value="true"
                                                disabled={isDisabled}
                                            />
                                        }
                                        label={
                                            <span className="gray-text mr-2">
                                                YES
                                            </span>
                                        }
                                        className="m-0"
                                    />
                                    <FormControlLabel
                                        control={
                                            <BaseRadio
                                                value="false"
                                                disabled={isDisabled}
                                            />
                                        }
                                        label={
                                            <span className="gray-text mr-2">
                                                NO
                                            </span>
                                        }
                                        className="m-0"
                                    />
                                </RadioGroup>
                            )}
                        />
                    </div> */}
                    <Controller
                        control={control}
                        name="accessory.roundCapacity"
                        defaultValue=""
                        rules={{ required: true, minLength: 1, maxLength: 3 }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                label="Round Capacity"
                                className="reddit-input w-100"
                                variant="filled"
                                disabled={isDisabled}
                                error={errors?.accessory?.roundCapacity && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'accessory.roundCapacity',
                                    'Round Capacity',
                                    'Round Capacity should be 3 digit'
                                )}
                            />
                        )}
                    />
                </Grid>
                <Grid item sm={4} xs={12} className="pt-2" container>
                    <Grid item xs={12}>
                        <Controller
                            control={control}
                            name="accessory.caliber"
                            defaultValue=""
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    label="Caliber"
                                    className="reddit-input w-100 mb-2"
                                    variant="filled"
                                    disabled={isDisabled}
                                    onKeyPress={(e: any) =>
                                        CommonService.allowsInput(e, [
                                            'alphabet',
                                            'numeric',
                                        ])
                                    }
                                    error={errors?.accessory?.caliber && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'accessory.caliber',
                                        'Caliber'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Controller
                            control={control}
                            name="accessory.dateOfPurchase"
                            defaultValue={null}
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <BaseDatePicker
                                    {...field}
                                    label="Date of Purchase"
                                    onChange={(e: any) => {
                                        onChange(e)
                                    }}
                                    value={value}
                                    fullWidth
                                    inputRef={ref}
                                    maxDate={new Date()}
                                    disabled={isDisabled}
                                    error={
                                        errors?.accessory?.dateOfPurchase &&
                                        true
                                    }
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'accessory.dateOfPurchase',
                                        'Date of Purchase'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid item sm={4} xs={12} className="pt-2">
                    <UploadImage
                        className="w-100"
                        style={{ height: '110px' }}
                        fileChanged={(e: string) =>
                            imageChanged(e, 'ACCESSORY')
                        }
                        id="upload-accessory"
                        imageUrl={watchAccessory?.imageUrl}
                        isLoading={watchAccessory?.loading}
                        disabled={isDisabled}
                        remove
                        removeAction={() => onRemoveImg('ACCESSORY')}
                    />
                </Grid>

                {/* accessory seller detail */}
                <Grid item sm={4} xs={12} className="pt-0" />
                <Grid item sm={4} xs={12} className="pt-0" />
                <Grid
                    item
                    sm={8}
                    xs={12}
                    className="pt-0"
                    container
                    spacing={2}
                >
                    <p className="page-title mt-5 w-100 ml-3">Seller Details</p>

                    <Grid item sm={6} xs={12} className="pt-2">
                        <Controller
                            control={control}
                            name="accessorySeller.ffl"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    label="FFL #"
                                    className="reddit-input w-100"
                                    variant="filled"
                                    disabled={isDisabled}
                                    onKeyPress={(e: any) =>
                                        CommonService.allowsInput(e, [
                                            'alphabet',
                                            'space',
                                            'numeric',
                                        ])
                                    }
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={6} xs={12} className="pt-2">
                        <Controller
                            control={control}
                            name="accessorySeller.businessName"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    label="Business Name"
                                    className="reddit-input w-100"
                                    variant="filled"
                                    disabled={isDisabled}
                                    onKeyPress={(e: any) =>
                                        CommonService.allowsInput(e, [
                                            'alphabet',
                                            'space',
                                            'numeric',
                                        ])
                                    }
                                />
                            )}
                        />
                    </Grid>

                    <Grid item sm={6} xs={12} className="pt-2">
                        <Controller
                            control={control}
                            name="accessorySeller.address"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    label="Address"
                                    className="reddit-input w-100"
                                    variant="filled"
                                    disabled={isDisabled}
                                    onKeyPress={(e: any) =>
                                        CommonService.allowsInput(e, [
                                            'alphabet',
                                            'space',
                                            'numeric',
                                        ])
                                    }
                                />
                            )}
                        />
                    </Grid>

                    <Grid item sm={6} xs={12} className="pt-2">
                        <Controller
                            control={control}
                            name="accessorySeller.state"
                            defaultValue=""
                            // rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <BaseCreatableSelect
                                    value={value}
                                    onChange={(event: any) => {
                                        onChange(event)
                                        handleSelectChange(event, 'STATE')
                                    }}
                                    options={states}
                                    label="State"
                                    fullWidth
                                    disabled={isDisabled}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={6} xs={12} className="pt-2" container>
                        <Grid item xs={12}>
                            <Controller
                                control={control}
                                name="accessorySeller.city"
                                defaultValue=""
                                // rules={{ required: true }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <BaseCreatableSelect
                                        value={value}
                                        onChange={onChange}
                                        options={cities}
                                        label="City"
                                        fullWidth
                                        className="mb-2"
                                        disabled={
                                            isDisabled ||
                                            !watchAccessorySeller?.state
                                        }
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                control={control}
                                name="accessorySeller.zipCode"
                                defaultValue=""
                                rules={{ minLength: 1, maxLength: 5 }}
                                render={({
                                    field: { ref, value, onChange, ...field },
                                }: any) => (
                                    <RedditTextField
                                        {...field}
                                        value={value}
                                        onChange={onChange}
                                        label="Zip Code"
                                        className="reddit-input w-100"
                                        variant="filled"
                                        disabled={isDisabled}
                                        error={
                                            errors?.accessorySeller?.zipCode &&
                                            true
                                        }
                                        helperText={FormService.getErrorMessage(
                                            errors,
                                            'accessorySeller.zipCode',
                                            'Zip Code',
                                            'Zip Code should be 1 to 5 digit'
                                        )}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid item sm={6} xs={12} className="pt-2">
                        <UploadFiles
                            remove
                            fileChanged={(e: string) =>
                                fileChanged(e, 'ACCESSORY_SELLER')
                            }
                            isLoading={watchAccessorySeller?.loading}
                            filename={watchAccessorySeller?.file?.name}
                            fileUrl={watchAccessorySeller?.file?.url}
                            removeAction={() =>
                                removeFileUpload('ACCESSORY_SELLER')
                            }
                        />
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

const mapStateToProps = (store: any) => {
    return {
        cities: store?.client.regrounds?.accessory_cities.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
        states: store?.client.regrounds?.accessory_states.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    return {
        getStates: (params?: ICommonQuery) =>
            dispatch(
                RegroundAction.getReground(
                    'STATE',
                    RegroundTypes.ACCESSORY_STATE,
                    params
                ) as any
            ),
        getCities: (params: any) =>
            dispatch(
                RegroundAction.getReground(
                    'CITY',
                    RegroundTypes.ACCESSORY_CITY,
                    params
                ) as any
            ),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccessoriesForm)
